import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
  useRef,
} from "react";
import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";
import ImageBrowse from "../../../../Common/Image/ImageBrowse";
import { IconPlus } from '@tabler/icons-react'
import PopularImages from "./PopularImages";

const About = forwardRef(function (props, ref) {
  const [section1Title, setSection1Title] = useState("");
  const [section1TagLine, setSection1TagLine] = useState("");
  const [section1ImageKey, setSection1ImageKey] = useState("");
  const section1ImageRef = useRef();

  const [section2Title, setSection2Title] = useState("");
  const [section2TagLine, setSection2TagLine] = useState("");
  const [section2ImageKey, setSection2ImageKey] = useState("");
  const section2ImageRef = useRef();

  const [errors, setErrors] = useState({});
    const [popularImages, setPopularImages] = useState([]);


    const data = {
      section1Title,
      section1TagLine,
      section1ImageKey,
      section2Title,
      section2TagLine,
      section2ImageKey,

    }



    useEffect(() => {
      if (props.data) {
        if (props.data.popularImages && Array.isArray(props.data.popularImages)) {
          setPopimgsData(props.data.popularImages);
        }
        if (props.data.length > 0) {
          setSection1Title(props.data[0].title);
          setSection1TagLine(props.data[0].tagLine);
          setSection1ImageKey(props.data[0].imageKey);
    
          // Ensure popularImages is not undefined before setting
         
    
          section1ImageRef?.current?.setThumbnail(props.data[0].image);
          section1ImageRef?.current?.setFileContent(props.data[0].imageFile);
        }
    
        if (props.data.length > 1) {
          setSection2Title(props.data[1].title || "");
          setSection2TagLine(props.data[1].tagLine || "");
          setSection2ImageKey(props.data[1].imageKey || "");
    
          section2ImageRef?.current?.setThumbnail(props.data[1].image);
          section2ImageRef?.current?.setFileContent(props.data[1].imageFile);
        }
      }
    }, [props.data]);
    

  const setPopimgsData = (data) => {
    let popimgsData = [];
    data.forEach((item, index) => {
        popimgsData.push({
        imgTitle: item.imgTitle,
        image: item.image,
        imageFile: item.imageFile,
        imageKey: item.imageKey,
        show: index == 0,
        ref: null
      })
    });

    setPopularImages(popimgsData);
  }



  const handleAddpopImg = () => {
    let image =
    {
      name: "News " + (popularImages.length + 1),
      image: null,
      imageFile: null,
      imageKey: "",
      show: popularImages.length == 0,
      ref: null,
    }

    setPopularImages([...popularImages, image]);
  }


  const showHidePopimgs = (index) => {
    const currentPopImgs = [...popularImages];

    currentPopImgs.forEach((people, innerIndex) => {
      if (index == innerIndex)
        people["show"] = !people["show"];
      else
        people["show"] = false;
    });

    setPopularImages(currentPopImgs);
  }


  const deletePopImgHandler = (targetIndex) => {
    const filteredPopImgs = popularImages.filter((item, index) => index !== targetIndex);

    if (filteredPopImgs.length == 1) {
        filteredPopImgs[0]["show"] = true;
    }

    const deletedPopImg = popularImages.filter((item, index) => index === targetIndex);

    if (deletedPopImg && deletedPopImg.length > 0) {
      if (deletedPopImg[0].imageKey != "")
        props.imageDelete(deletedPopImg[0].imageKey);
    }
    setPopularImages(filteredPopImgs);
  }

  const imageDeleteHandler = (imageKey) => {
    props.imageDelete(imageKey);
  }




  const validate = () => {
    const errors = {};
    return Object.keys(errors).length === 0;
  };
  const getData = () => {
    let aboutData = [];
    popularImages.forEach(about =>{
      let data = about.ref?.getData() ?? null;
      if(data)
        aboutData.push(data);
    });
    return [
      {
        abouts:aboutData,
        title: section1Title,
        tagLine: section1TagLine,
        image: section1ImageRef?.current?.getThumbnail() ?? null,
        imageFile: section1ImageRef?.current?.getImageFile() ?? null,
        imageKey: section1ImageKey,
      },
      
    ];
  };

  useImperativeHandle(ref, () => ({
    getData: getData,
    validate: validate,
  }));
  const handleCroppedImage = (file) => {
const updatedData = [{ ...data, herofile: file }];
console.log("updatedData",updatedData)
if (props.onDataReceive) {
  props.onDataReceive(updatedData); 
}
  };
  return (
    <>
      <div className="content d-block visible">
      <div className="content-header mb-3 d-flex justify-content-between">
          <div className="sec-titler">
            <h2 className="text-primary">About Page</h2>
            <div className="title-shape"></div>
            <small className="fs-11 mb-0"></small>
          </div>
          <div className="mb-0 text-right">
            <button className="btn btn-primary align-middle" onClick={handleAddpopImg}>
              <IconPlus className="me-sm-1 me-0" size={20} />
              Add News
            </button>
          </div>
        </div>
        <div className="accordion mt-3">
            {popularImages && popularImages.length > 0 &&
              popularImages.map((people, index) => {
                return (
                  <PopularImages
                    data={people}
                    index={index}
                    showHidePople={showHidePopimgs}
                    deletePeople={deletePopImgHandler}
                    imageDelete={imageDeleteHandler}
                    key={index}
                    ref={el => people.ref = el} />
                )
              })
            }
          </div>

            <StepperNavigationButtons
              index={props.index}
              steps={props.steps}
              navigate={props.navigate}
            />
      </div>
    </>
  );
});

export default About;
